module.exports = __webpack_public_path__ + "static/media/gryphon_musee_everyartoriginal_1.e480f0f9.jpg";